import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ApiService from "../../../services/api";
import { Col, Container, Row } from "react-bootstrap";
import parse from "html-react-parser";
import "../css/news_page.css";
import { AuthContext } from "../../../services/auth";
import env from "../../../env";
import moment from "moment";

const NewsPage = () => {
  const { isEnglish } = useContext(AuthContext);
  const [idNews, setIdNews] = useState({});
  const [Loading, setLoading] = useState(true);
  const { slugNews } = useParams();

  const fetchCategory = async () => {
    const newsID = await ApiService.getNewsID(slugNews);
    setIdNews(newsID);
    setLoading(false);
  };

  useEffect(() => {
    fetchCategory();
  }, [slugNews]);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className="padding_custom text-center">
      <img
        src={idNews.image}
        alt={idNews.image}
        className="img-news-page h-100 w-100 mb-4"
      ></img>

      <Container fluid className="m-0 p-0  container-text-body-news">
        <Container className="text-center">
          <h6 className="text_data">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-calendar3 me-2"
              viewBox="0 0 16 16"
            >
              <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
              <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
            </svg>
            {moment(idNews.date).format("DD/MM/YYYY")}
          </h6>
          <h2 className="my-4 mt-5 fs-1 section-title text-uppercase">
            {isEnglish ? idNews.title_eng : idNews.title}
          </h2>
          <div className="border-custom mt-3"></div>
          <Row className="section-text">
            <Col className="col-12 container-text-news-page">
              <h6 className="my-5 text_news_page text-start">
                {isEnglish
                  ? parse(idNews.description_eng)
                  : parse(idNews.description)}
              </h6>
            </Col>
            <Col className="col-12 mb-5">
              {idNews.attachments.length > 0 && (
                <>
                  <h3 className="mt-3 section-subtitle">
                    {isEnglish ? "Attachments" : "Allegati"}
                  </h3>
                  <div className="border-custom mb-2"></div>
                  {idNews.attachments.map((file, index) => (
                    <div
                      className="admin-attachments-wrapper"
                      key={"key_attachment_" + index}
                    >
                      <div className="mb-2">
                        <div
                          icon="it-file"
                          size="sm"
                          className="attachment-icon py-1 site-link"
                        />
                        <a
                          href={env.BACKEND_BASE_URL + file.url}
                          target="_blank"
                          rel="noreferrer"
                          className="text_data site-link"
                        >
                          {file.name}
                        </a>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </Col>
          </Row>
        </Container>
      </Container>
    </Container>
  );
};
export default NewsPage;
